import React, { FC } from 'react'
import EditIcon from 'transfix-icons/build/EditIcon'
import { IconButton } from 'transfix-ui/components/IconButton'
import { Spinner } from 'transfix-ui/components/Spinner'
import {
  DisplayTile,
  DisplayTileHeader,
  DisplayTileHeaderAction,
  DisplayTileSection,
} from 'apps/fleet-planner/components/atoms/DisplayTile'
import { FacilityContactInfo } from 'apps/fleet-planner/components/load-details/stops/FacilityContactInfo'
import { ICustomerContact } from 'apps/fleet-planner/types'
import 'assets/scss/5_components/_display-tile.scss'

export interface IFacilityAddressForm {
  addressee?: string | null
  addressLine1?: string | null
  addressLine2?: string | null
  locality?: string
  subdivisionCode?: string
  postalCode?: string | null
}

interface IFacilityDisplayTileProps {
  facilityAddress?: IFacilityAddressForm
  facilityContact?: ICustomerContact
  facilityName?: string | null
  isEditModeEnabled?: boolean
  isLoading: boolean
  onEdit?: () => void
}

const FacilityDisplayTile: FC<IFacilityDisplayTileProps> = ({
  facilityAddress,
  facilityContact,
  facilityName,
  isEditModeEnabled,
  isLoading,
  onEdit,
}) => {
  const { addressLine1, addressLine2, locality, postalCode, subdivisionCode } =
    facilityAddress || {}

  return (
    <DisplayTile>
      {isLoading ? (
        <div className='spinner-wrapper'>
          <Spinner position='relative' />
        </div>
      ) : (
        <>
          <DisplayTileHeader>
            {isEditModeEnabled && (
              <DisplayTileHeaderAction>
                <IconButton
                  Icon={EditIcon}
                  onClick={onEdit}
                  data-test='edit-facility'
                  label='Edit Facility'
                  size='large'
                />
              </DisplayTileHeaderAction>
            )}
            <div>{facilityName}</div>
          </DisplayTileHeader>
          <DisplayTileSection>
            <div>{addressLine1}</div>
            {!!addressLine2 && <div>{addressLine2}</div>}
            <div>
              {locality}, {subdivisionCode} {postalCode}
            </div>
          </DisplayTileSection>
          <FacilityContactInfo facilityContact={facilityContact} />
        </>
      )}
    </DisplayTile>
  )
}

export default FacilityDisplayTile
